import { useState } from 'react'

import { ReactComponent as ThanxAiSparkles } from 'assets/images/thanx-ai-sparkles.svg'
import ThanxAIPromptInput from 'components/AI/ThanxAIPromptInput'
import ThanxAISuggestionList from 'components/AI/ThanxAISuggestionList'
import Formsy from 'formsy-react'
import { buildTranslate } from 'locales'
import './ThanxAIPrompt.scss'

const t = buildTranslate('components.ai.prompt')

export interface ThanxAIPromptProps {
  title: string
  subtitle?: string
  placeholder: string
  suggestions: string[]
  onSubmit: (prompt: string) => void
  submitText?: string
}

const ThanxAIPrompt = ({
  title,
  subtitle,
  placeholder,
  suggestions,
  onSubmit,
  submitText = t('default_submit_text'),
}: ThanxAIPromptProps) => {
  const [prompt, setPrompt] = useState('')

  const handleSubmit = (submittedPrompt: string) => {
    onSubmit(submittedPrompt)
    setPrompt('') // Clear input after submission
  }

  const handleSuggestionClick = (suggestion: string) => {
    setPrompt(suggestion)
  }

  return (
    <div className="thanx-ai-prompt">
      <div className="thanx-ai-prompt__content">
        <div className="thanx-ai-prompt__header">
          <div className="thanx-ai-prompt__title-row">
            <div className="thanx-ai-prompt__sparkle-icon" aria-hidden="true">
              <ThanxAiSparkles />
            </div>
            <h2 className="thanx-ai-prompt__title">{title}</h2>
          </div>
          {subtitle && <p className="thanx-ai-prompt__subtitle">{subtitle}</p>}
        </div>

        <Formsy onSubmit={model => handleSubmit(model.prompt)}>
          <ThanxAIPromptInput
            name="prompt"
            placeholder={placeholder}
            submitText={submitText}
            initialValue={prompt}
          />
        </Formsy>

        <ThanxAISuggestionList
          suggestions={suggestions}
          onSuggestionClick={handleSuggestionClick}
        />
      </div>
    </div>
  )
}

export default ThanxAIPrompt
